/**
 * To be invoked like this:
  retry({
    maxAttempts: 5, // max number of attempts
    checkEvery: 3000, // millisecs
    checkFunction: () => Boolean(window.__satelliteLoaded), // condition to be successfull
  })
  .then(() => < DO_STH >) // check succeeded
  .catch(() => < DO_STH_ELSE >); // check failed
 */
export const retry = ({
  maxAttempts,
  checkEvery,
  checkFunction,
  counter = 0,
}: {
  maxAttempts: number;
  checkEvery: number;
  checkFunction: () => {};
  counter?: number;
}) =>
  new Promise((resolve, reject) => {
    if (counter <= maxAttempts) {
      if (!checkFunction()) {
        setTimeout(async () => {
          try {
            await retry({ maxAttempts, checkEvery, checkFunction, counter: counter + 1 });
            resolve(true);
          } catch (err) {
            reject(err);
          }
        }, checkEvery);
      } else {
        resolve(true);
      }
    } else {
      reject(new Error('Retries ended'));
    }
  });
